import { formPrefillEvent } from "@/components/forms/public-form";

export const SUPPORT_FORM_ID = "contact-support";

/** Jump to the support form and optionally pre-select a Subject. */
export function requestSupport(subject?: string) {
  if (typeof window === "undefined") return;

  if (subject) {
    window.dispatchEvent(
      new CustomEvent(formPrefillEvent("support"), { detail: { subject } }),
    );
  }

  const target = document.getElementById(SUPPORT_FORM_ID);
  if (target) {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }
}
